class CheckoutRedirectHelper {
    static async redirectToPaymentPage({ sessionId, url }, paymentProvider, stripe) {
        if (paymentProvider === 'GuestPay') {
            window.sessionStorage.setItem('guestpay_pending_session', sessionId);
            window.location.href = url || sessionId;
        } else if (url) {
            window.location.href = url;
        } else {
            await stripe.redirectToCheckout({ sessionId });
        }
    }
}
export default CheckoutRedirectHelper;
